export function formatShowValue(val, presetAry) {
    if (!Array.isArray(presetAry)) {
        return val
    }
    const found = presetAry.find(ele => {
        return ele.value === val
    })
    if (found) {
        return found.showName
    }
    return val
}

// 获取预设配置
export function getPresetConfig(emPre) {
    const result = {
        ratePreset: [],
        humanizePreset: [],
        flexPreset: [],
        vibratoPreset: [],
        trackingPreset: [],
    }
    for (const key in emPre.rate) {
        if (checkPreset(emPre.rate[key])) {
            result.ratePreset.push({
                name: emPre.rate[key].name,
                showName: spliceStr(emPre.rate[key].name),
                value: emPre.rate[key].value
            })
        }
    }
    for (const key in emPre.humanize) {
        if (checkPreset(emPre.humanize[key])) {
            result.humanizePreset.push({
                name: emPre.humanize[key].name,
                showName: spliceStr(emPre.humanize[key].name),
                value: emPre.humanize[key].value
            })
        }
    }
    for (const key in emPre.flex) {
        if (checkPreset(emPre.flex[key])) {
            result.flexPreset.push({
                name: emPre.flex[key].name,
                showName: spliceStr(emPre.flex[key].name),
                value: emPre.flex[key].value
            })
        }
    }
    for (const key in emPre.vibrato) {
        if (checkPreset(emPre.vibrato[key])) {
            result.vibratoPreset.push({
                name: emPre.vibrato[key].name,
                showName: spliceStr(emPre.vibrato[key].name),
                value: emPre.vibrato[key].value
            })
        }
    }
    for (const key in emPre.tracking) {
        if (checkPreset(emPre.flex[key])) {
            result.trackingPreset.push({
                name: emPre.tracking[key].name,
                showName: spliceStr(emPre.tracking[key].name),
                value: emPre.tracking[key].value
            })
        }
    }
    return result
}

// 获取快捷键配置
export function getShortcutList(shortcut, emModelShortcut, emModel, isSetShortcutByEmModel) {
    const result = []
    let target = shortcut
    if (isSetShortcutByEmModel) {
        target = emModelShortcut[emModel]
    }
    for (const key in target) {
        const item = target[key]
        if (item.name) {
            result.push({
                name: item.name,
                showName: spliceStr(item.name, 3),
                rate: item.rate,
                humanize: item.humanize,
                flex: item.flex,
                vibrato: item.vibrato,
                tracking: item.tracking,
            })
        }
    }
    return result;
}
export function getCurrentShortcutName(shortcutList, shortcutLink, emValue) {
    let result = '';
    const temp = []
    for (const key in shortcutLink) {
        if (shortcutLink[key]) {
            temp.push(key)
        }
    }
    if (temp.length === 0) {
        return result
    }
    shortcutList.forEach(ele => {
        if (temp.every(key => ele[key] === emValue[key])) {
            result = ele.name
        }
    });
    return result;
}

function checkPreset(cnf) {
    return cnf && cnf.name && typeof cnf.value === 'number'
}
function spliceStr(str, len = 2) {
    if (!str || typeof str !== "string") {
        return ""
    }
    return str.slice(0, len)
}

// 推杆配置
export const sliderConfig = {
    step: 1,
    min: 0,
    max: 100,
}

const EmValueNameObj = {
    rate: "强度",
    humanize: "拟人",
    flex: "弹性",
    vibrato: "颤音",
    tracking: "跟踪",
}
// 获取快捷配置的关联选项名称
export const getShortcutLinkNames = (shortcutLink) => {
    if (!shortcutLink || typeof shortcutLink !== "object") {
        return []
    }
    const result = [];
    for (const key in shortcutLink) {
        if (shortcutLink[key] && EmValueNameObj[key]) {
            result.push(EmValueNameObj[key])
        }
    }
    return result
}
// 获取联动调节关联项名称
export const getLinkageNames = (linkage) => {
    if (!linkage || typeof linkage !== "object") {
        return []
    }
    const result = [];
    for (const key in linkage) {
        if (linkage[key] && linkage[key]["isLink"] && EmValueNameObj[key]) {
            result.push(EmValueNameObj[key])
        }
    }
    return result
}

export const getSectionHeight = (pagestet) => {
    let h = 11;
    if (pagestet.emModel) {
        h += 28;
    }
    if (pagestet.shortcut) {
        h += 24;
    }
    if (pagestet.emRate) {
        h += 24;
    }
    if (pagestet.emHumanize) {
        h += 24;
    }
    if (pagestet.emFlex) {
        h += 24;
    }
    if (pagestet.emVibrato) {
        h += 24;
    }
    if (pagestet.emTracking) {
        h += 24;
    }
    if (pagestet.emLinkage) {
        h += 24;
    }
    if (h < 35) {
        h = 35
    }
    return h;
}

